import { apiClient } from '@/libs/axios';
import {
  toNotificationDeliveryDetailDTO,
  type NotificationDeliveryDetailDTO,
} from '../schemas/get-notification-delivery.schema';

export const GET_NOTIFICATION_DELIVERY_QUERY_KEY = 'notification-delivery';

export const getNotificationDelivery = async (
  id: string
): Promise<NotificationDeliveryDetailDTO> => {
  const response = await apiClient.get(`notification-delivery/${id}`);

  return toNotificationDeliveryDetailDTO(response);
};
